var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}]},[_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"600"},model:{value:(_vm.showEditNode),callback:function ($$v) {_vm.showEditNode=$$v},expression:"showEditNode"}},[(_vm.selectedNode && _vm.showEditNode)?_c('v-card',[_c('v-card-text',{key:_vm.selectedNode.id},[_c('intent-manage',{on:{"onCancel":_vm.onCancelIntent,"onSave":_vm.onSaveIntent},model:{value:(_vm.selectedNode),callback:function ($$v) {_vm.selectedNode=$$v},expression:"selectedNode"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"1000"},model:{value:(_vm.showEditApi),callback:function ($$v) {_vm.showEditApi=$$v},expression:"showEditApi"}},[(_vm.selectedNode && _vm.showEditApi && !_vm.loadingApiList)?_c('v-card',[_c('v-card-text',{key:_vm.selectedNode.id},[_c('api-manage',{on:{"onCancel":_vm.onCancelApi,"onSave":_vm.onSaveApi},model:{value:(_vm.selectedNode),callback:function ($$v) {_vm.selectedNode=$$v},expression:"selectedNode"}},[_c('div',{staticClass:"text-xs-right",attrs:{"slot":"header"},slot:"header"},[_c('v-btn',{attrs:{"fab":"","flat":"","small":""},on:{"click":_vm.onCancelApi}},[_c('v-icon',[_vm._v("close")])],1)],1)])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"600"},model:{value:(_vm.showEditRandom),callback:function ($$v) {_vm.showEditRandom=$$v},expression:"showEditRandom"}},[(_vm.selectedNode && _vm.showEditRandom)?_c('v-card',[_c('v-card-text',{key:_vm.selectedNode.id},[_c('random-manage',{on:{"onCancel":_vm.onCancelRandom,"onSave":_vm.onSaveRandom},model:{value:(_vm.selectedNode),callback:function ($$v) {_vm.selectedNode=$$v},expression:"selectedNode"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"1000"},model:{value:(_vm.showEditCondition),callback:function ($$v) {_vm.showEditCondition=$$v},expression:"showEditCondition"}},[(_vm.selectedNode && _vm.showEditCondition)?_c('v-card',[_c('v-card-text',{key:_vm.selectedNode.id},[_c('condition-manage',{on:{"onSave":_vm.onSaveCondition,"onCancel":_vm.onCancelCondition},model:{value:(_vm.selectedNode),callback:function ($$v) {_vm.selectedNode=$$v},expression:"selectedNode"}},[_c('div',{staticClass:"text-xs-right",attrs:{"slot":"header"},slot:"header"},[_c('v-btn',{attrs:{"fab":"","flat":"","small":""},on:{"click":_vm.onCancelCondition}},[_c('v-icon',[_vm._v("close")])],1)],1)])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"600"},model:{value:(_vm.showConnection),callback:function ($$v) {_vm.showConnection=$$v},expression:"showConnection"}},[(_vm.selectedNode && _vm.showConnection)?_c('v-card',[_c('v-card-text',{key:_vm.selectedNode.id,staticClass:"pa-2"},[_vm._l((_vm.selectedNode.connected_intents),function(connection,index){return _c('v-card',{key:'connection_' + index},[_c('v-card-text',[_vm._v(_vm._s(connection))])],1)}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"outline":"","color":"grey"},on:{"click":function($event){_vm.showConnection = false}}},[_vm._v(_vm._s(_vm.$t('Close')))])],1)],2)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"600"},model:{value:(_vm.showEditText),callback:function ($$v) {_vm.showEditText=$$v},expression:"showEditText"}},[(_vm.selectedNode && _vm.showEditText)?_c('v-card',[_c('v-card-text',{key:_vm.selectedNode.id},[_c('question-manage',{model:{value:(_vm.selectedQuestionText),callback:function ($$v) {_vm.selectedQuestionText=$$v},expression:"selectedQuestionText"}},[(_vm.selectedNode.isConnected)?_c('v-btn',{attrs:{"slot":"delete-connection","outline":"","color":"primary"},on:{"click":_vm.onDeleteConnection},slot:"delete-connection"},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("delete")]),_vm._v("Delete\n          ")],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-right",attrs:{"slot":"header"},slot:"header"},[_c('v-btn',{attrs:{"fab":"","flat":"","small":""},on:{"click":_vm.onCancelEditText}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"outline":"","color":"grey"},on:{"click":_vm.onCancelEditText}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","depressed":""},on:{"click":_vm.onSaveEditText}},[_vm._v(_vm._s(_vm.$t('Save')))])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"600"},model:{value:(_vm.showEditDefault),callback:function ($$v) {_vm.showEditDefault=$$v},expression:"showEditDefault"}},[(_vm.selectedNode && _vm.showEditDefault)?_c('v-card',[_c('v-card-text',{key:_vm.selectedNode.id},[_c('default-manage',{on:{"onSave":_vm.onSaveEditDefault,"onCancel":_vm.onCancelEditDefault,"onDeleteConnection":_vm.onDeleteConnection},model:{value:(_vm.selectedNode),callback:function ($$v) {_vm.selectedNode=$$v},expression:"selectedNode"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"1000"},model:{value:(_vm.showEditFlow),callback:function ($$v) {_vm.showEditFlow=$$v},expression:"showEditFlow"}},[(_vm.selectedNode && _vm.showEditFlow)?_c('v-card',[_c('v-card-text',[_c('flow-manage',{on:{"onSave":_vm.onSaveEditFlow,"onCancel":_vm.onCancelEditFlow},model:{value:(_vm.selectedNode),callback:function ($$v) {_vm.selectedNode=$$v},expression:"selectedNode"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"1000"},model:{value:(_vm.showEditVariable),callback:function ($$v) {_vm.showEditVariable=$$v},expression:"showEditVariable"}},[(_vm.selectedNode && _vm.showEditVariable)?_c('v-card',[_c('v-card-text',[_c('variable-manage',{on:{"onSave":_vm.onSaveEditVariable,"onCancel":_vm.onCancelEditVariable},model:{value:(_vm.selectedNode),callback:function ($$v) {_vm.selectedNode=$$v},expression:"selectedNode"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"400"},model:{value:(_vm.showEditPersistent),callback:function ($$v) {_vm.showEditPersistent=$$v},expression:"showEditPersistent"}},[(_vm.showEditPersistent)?_c('v-card',[_c('v-card-text',[_c('ul',{staticStyle:{"padding":"0","margin":"auto","max-width":"300px"}},[_c('li',{staticStyle:{"list-style-type":"none","padding":"10px 0px","color":"black","text-align":"center","border-top-left-radius":"10px","border-top-right-radius":"10px","border":"1px solid #dddfe2","border-bottom":"0"}},[_c('div',{staticClass:"strong"},[_vm._v(_vm._s(_vm.$t('Main menu')))])]),_vm._v(" "),(_vm.tmpPersistentMenu.length > 0)?_vm._l((_vm.tmpPersistentMenu),function(menu,index){return _c('li',{key:'menu_' + index + '_' + menu.title,class:{
                'persistent-menu-bottom': index == 20 - 1
              },staticStyle:{"position":"relative","list-style-type":"none","border":"1px solid #dddfe2","border-top":"1px solid #dddfe2"}},[_c('add-button-persistent-menu',{attrs:{"hasNested":true,"onEdit":true},on:{"onDelete":function($event){return _vm.deleteMenu(index)}},model:{value:(_vm.tmpPersistentMenu[index]),callback:function ($$v) {_vm.$set(_vm.tmpPersistentMenu, index, $$v)},expression:"tmpPersistentMenu[index]"}},[_c('template',{slot:"append"},[_c('v-list-tile',{attrs:{"disabled":index <= 0},on:{"click":function($event){return _vm.onMoveButton(index, 'up', _vm.tmpPersistentMenu)}}},[_c('v-list-tile-title',{staticClass:"primary-color",style:(index <= 0 ? "color: lightgrey" : '')},[_vm._v(_vm._s(_vm.$t('Move up')))])],1),_vm._v(" "),_c('v-list-tile',{attrs:{"disabled":index >= _vm.tmpPersistentMenu.length - 1},on:{"click":function($event){return _vm.onMoveButton(index, 'down', _vm.tmpPersistentMenu)}}},[_c('v-list-tile-title',{staticClass:"primary-color",style:(index >= _vm.tmpPersistentMenu.length - 1 ? "color: lightgrey" : '')},[_vm._v(_vm._s(_vm.$t('Move down')))])],1)],1)],2),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1)}):void 0,_vm._v(" "),(_vm.tmpPersistentMenu.length < 20)?_c('li',{staticStyle:{"list-style-type":"none","border":"1px dashed #dddfe2","border-top":"0","padding":"10px 0px","overflow":"auto","text-align":"center","border-bottom-left-radius":"10px","border-bottom-right-radius":"10px"}},[_c('a',{staticClass:"primary-color",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.addMenu}},[_c('span',{staticClass:"fa fa-plus"}),_vm._v("\n              "+_vm._s(_vm.$t('Add menu'))+"\n            ")])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"outline":"","color":"grey"},on:{"click":_vm.onCancelPersistent}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","depressed":""},on:{"click":_vm.onSavePersistent}},[_vm._v(_vm._s(_vm.$t('Save')))])],1)])],1):_vm._e()],1),_vm._v(" "),(!_vm.loading)?_c('div',[(_vm.nodes.length == 0)?_c('div',{staticStyle:{"width":"100%","padding-top":"60px","padding-left":"90px","padding-right":"10px","overflow":"auto"},style:({ height: _vm.maxHeight + 'px' })},[_c('v-card',[_c('div',[_c('intent-manage',{on:{"onSave":_vm.onSaveStartNode},scopedSlots:_vm._u([{key:"footer",fn:function(scope){return _c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","depressed":""},on:{"click":scope.onSave}},[_vm._v(_vm._s(_vm.$t('Save')))])],1)}}],null,false,2905577558),model:{value:(_vm.newNode),callback:function ($$v) {_vm.newNode=$$v},expression:"newNode"}})],1)])],1):[_c('v-stage',{ref:"stage",attrs:{"config":{
          width: _vm.configKonva.width,
          height: _vm.configKonva.height,
          x: _vm.configKonva.x,
          y: _vm.configKonva.y,
          draggable: !_vm.onHoldShift,
          scale: _vm.configKonva.scale
        }},on:{"wheel":_vm.onZoom,"dragstart":_vm.onStageDragStart,"dragend":_vm.onStageDragEnd,"mousedown":_vm.onStageMouseDown,"mouseup":_vm.onStageMouseUp,"mousemove":_vm.onStageMouseMove,"click":_vm.onStageClick}},[_c('v-layer',{ref:"layer"},[(_vm.selectedArea)?_c('v-rect',{ref:"selectionrect",attrs:{"config":{
              x: _vm.selectedArea.x,
              y: _vm.selectedArea.y,
              height: _vm.selectedArea.height,
              width: _vm.selectedArea.width,
              visible: _vm.selectedArea.visible,
              fill: '#9eff2040',
              stroke: '#9eff20'
            }}}):_vm._e(),_vm._v(" "),(_vm.tmpPersistentMenu.length > 0)?[_vm._l((_vm.persistentConnections),function(line){return [_c('v-line',{key:line.id,attrs:{"config":{
                  stroke: '#9e9e9e',
                  strokeWidth: 3,
                  bezier: line.isBezier,
                  points: line.points,
                  tension: line.tension ? line.tension : 0
                }}})]})]:_vm._e(),_vm._v(" "),_vm._l((_vm.nodes),function(node,index){return [_c('v-group',{key:("node_group_" + (node.id)),ref:("node_group_" + (node.id)),refInFor:true},[(_vm.showDebug)?_c('v-text',{attrs:{"config":{
                  text: node.id + " (" + (node.x) + "," + (node.y) + ")",
                  x: node.x,
                  y: node.y - 20
                }}}):_vm._e(),_vm._v(" "),(node.isSearch)?_c('v-rect',{key:'node_bg_search_' + index,attrs:{"config":{
                  x: _vm.checkNaN(node.x),
                  y: _vm.checkNaN(node.y),
                  width: 300,
                  height: _vm.checkNaN(60 + (node.height ? node.height : _vm.nodeHeight)),
                  fill: 'transparent',
                  strokeWidth: 8,
                  stroke: 'red',
                  opacity: 1,
                  cornerRadius: 10
                }}}):_vm._e(),_vm._v(" "),(node)?_c('v-rect',{key:'node_bg_' + index,attrs:{"config":{
                  x: _vm.checkNaN(node.x),
                  y: _vm.checkNaN(node.y),
                  width: 300,
                  height: _vm.checkNaN(60 + (node.height ? node.height : _vm.nodeHeight)),
                  fill: _vm.currentNodeMouserOver.includes(node.id) ? '#d9ffd2' : 'white',
                  strokeWidth: 1,
                  stroke: '#eee',
                  opacity: 0.9,
                  cornerRadius: 10
                }}}):_vm._e(),_vm._v(" "),_c('v-rect',{key:'node_start_node_' + index,attrs:{"config":{
                  x: _vm.checkNaN(node.x),
                  y: _vm.checkNaN(node.y),
                  cornerRadius: [10, 10, 0, 0],
                  width: 300,
                  height: 50,
                  fill: node.fillHeader ? node.fillHeader : 'white'
                }}}),_vm._v(" "),_c('v-text',{key:'node_title_' + index,ref:("node_title_" + index),refInFor:true,attrs:{"config":{
                  text: node.intentname,
                  width: 300,
                  height: 50,
                  fill: 'black',
                  fontSize: 18,
                  align: 'center',
                  x: _vm.checkNaN(node.x),
                  y: _vm.checkNaN(node.y) + 15
                }}}),_vm._v(" "),(node.type == 'start_node')?[(!_vm.loadingPersistentMenu && _vm.persistentMenu)?[_c('v-rect',{key:'node_persistent_bg',attrs:{"config":{
                      x: _vm.checkNaN(node.x) - 830,
                      y: _vm.checkNaN(
                        node.y + 42 + (node.height ? node.height / 2 : _vm.nodeHeight / 2) - 12
                      ),
                      width: 300,
                      height: _vm.buttonHeight * (_vm.persistentMenu.length || 1),
                      fill: 'white',
                      strokeWidth: 1,
                      stroke: '#eee',
                      opacity: 0.9,
                      cornerRadius: 10
                    }}}),_vm._v(" "),_vm._l((_vm.persistentMenu),function(actions,pindex){return [_c('v-rect',{key:("node_persistent_title_bg_" + pindex),attrs:{"config":{
                        width: 300,
                        height: _vm.buttonHeight ? _vm.buttonHeight : 50,
                        cornerRadius:
                          _vm.persistentMenu.length == 1
                            ? [10, 10, 10, 10]
                            : pindex == 0
                            ? [10, 10, 0, 0]
                            : _vm.persistentMenu.length - 1 == pindex
                            ? [0, 0, 10, 10]
                            : [0, 0, 0, 0],
                        strokeWidth: 2,
                        stroke: '#eee',
                        y:
                          node.y +
                          42 +
                          (node.height ? node.height / 2 : _vm.nodeHeight / 2) -
                          12 +
                          _vm.buttonHeight * pindex,
                        x: _vm.checkNaN(node.x) - 830
                      }}}),_vm._v(" "),_c('v-text',{key:'node_persistent_title_' + pindex,attrs:{"config":{
                        text: actions.title,
                        x: _vm.checkNaN(node.x) - 830,
                        y: _vm.checkNaN(
                          node.y +
                            42 +
                            (node.height ? node.height / 2 : _vm.nodeHeight / 2) -
                            12 +
                            _vm.buttonHeight * pindex
                        ),
                        width: 300,
                        height: _vm.buttonHeight,
                        fontSize: 16,
                        align: 'center',
                        padding: 10,
                        offset: {
                          y: -10
                        }
                      }}}),_vm._v(" "),(actions.type == 'postback')?_c('v-circle',{key:("node_persistent_point_" + (node.id) + "_" + pindex),ref:("node_persistent_point_" + (node.id) + "_" + pindex),refInFor:true,attrs:{"config":{
                        radius: 6,
                        y:
                          node.y +
                          42 +
                          (node.height ? node.height / 2 : _vm.nodeHeight / 2) -
                          12 +
                          _vm.buttonHeight * pindex +
                          _vm.buttonHeight / 2,
                        x: _vm.checkNaN(node.x) - 530,
                        fill: '#61a9de',
                        stroke: '#61a9de',
                        strokeWidth: 1,
                        type: 'point'
                      }}}):_vm._e()]}),_vm._v(" "),(_vm.persistentMenu.length == 0)?[_c('v-text',{attrs:{"config":{
                        text: '+ Add Persistent Menu',
                        x: _vm.checkNaN(node.x) - 830,
                        y: _vm.checkNaN(
                          node.y + 42 + (node.height ? node.height / 2 : _vm.nodeHeight / 2) - 12
                        ),
                        width: 300,
                        height: _vm.buttonHeight,
                        fontSize: 16,
                        align: 'center',
                        padding: 10,
                        offset: {
                          y: -10
                        }
                      }}})]:_vm._e(),_vm._v(" "),_c('v-rect',{key:'node_persistent_actions',attrs:{"config":{
                      x: _vm.checkNaN(node.x) - 830,
                      y: _vm.checkNaN(
                        node.y + 42 + (node.height ? node.height / 2 : _vm.nodeHeight / 2) - 12
                      ),
                      width: 300,
                      height: _vm.buttonHeight * (_vm.persistentMenu.length || 1),
                      cornerRadius: 10
                    }},on:{"click":_vm.editPersistentMenu}})]:_vm._e(),_vm._v(" "),_c('v-rect',{key:'node_start_bg_' + index,attrs:{"config":{
                    x: _vm.checkNaN(node.x) - 430,
                    y: _vm.checkNaN(
                      node.y + 42 + (node.height ? node.height / 2 : _vm.nodeHeight / 2) - 12
                    ),
                    width: 300,
                    height: 25 + (node.questionHeight ? node.questionHeight : 0),
                    fill: 'white',
                    strokeWidth: 1,
                    stroke: '#eee',
                    opacity: 0.9,
                    cornerRadius: 10
                  }}}),_vm._v(" "),_c('v-text',{key:'node_start_title_' + index,attrs:{"config":{
                    text: 'User input to flow',
                    x: _vm.checkNaN(node.x) - 430,
                    y: _vm.checkNaN(
                      node.y + 42 + (node.height ? node.height / 2 : _vm.nodeHeight / 2) - 12
                    ),
                    fill: '#61a9de',
                    width: 300,
                    fontSize: 16,
                    align: 'center',
                    padding: 10
                  }}}),_vm._v(" "),_c('v-text',{key:'node_start_' + index,ref:'node_start_' + node.id,refInFor:true,attrs:{"config":{
                    text: node.question,
                    x: _vm.checkNaN(node.x) - 430,
                    y: _vm.checkNaN(
                      node.y + 42 + 25 + (node.height ? node.height / 2 : _vm.nodeHeight / 2) - 12
                    ),
                    fill: 'black',
                    width: 300,
                    fontSize: 16,
                    align: 'center',
                    padding: 10
                  }}}),_vm._v(" "),_c('v-regular-polygon',{key:("node_start_point_in_" + (node.id)),ref:("node_start_point_in_" + (node.id)),refInFor:true,attrs:{"config":{
                    sides: 3,
                    radius: 10,
                    y: _vm.checkNaN(
                      node.y +
                        42 +
                        (node.height ? node.height / 2 : _vm.nodeHeight / 2) +
                        (node.questionHeight ? node.questionHeight / 2 : 0)
                    ),
                    x: _vm.checkNaN(node.x) - 430,
                    fill: '#61a9de',
                    rotation: 90
                  }}}),_vm._v(" "),_c('v-circle',{key:("node_start_point_" + (node.id)),ref:("node_start_point_" + (node.id)),refInFor:true,attrs:{"config":{
                    radius: 6,
                    y: _vm.checkNaN(
                      node.y +
                        42 +
                        (node.height ? node.height / 2 : _vm.nodeHeight / 2) +
                        (node.questionHeight ? node.questionHeight / 2 : 0)
                    ),
                    x: _vm.checkNaN(node.x) - 130,
                    fill: '#61a9de',
                    stroke: '#61a9de',
                    strokeWidth: 1,
                    type: 'point'
                  }}})]:_vm._e(),_vm._v(" "),_c('v-line',{key:'node_line_' + index,ref:("node_line_" + index),refInFor:true,attrs:{"config":{
                  x: _vm.checkNaN(node.x),
                  y: _vm.checkNaN(node.y),
                  strokeWidth: 2,
                  points: [0, 50, 300, 50],
                  stroke: '#eee'
                }}}),_vm._v(" "),(node.type == 'api')?[(node.answer && node.answer.length > 0 && node.answer[0].length > 0)?[_c('v-rect',{key:("node_message_method_" + (node.id)),ref:("node_message_method_" + (node.id)),refInFor:true,attrs:{"config":{
                      width: 60,
                      height: 30,
                      cornerRadius: 50,
                      fill: '#61a9de',
                      y: _vm.checkNaN(node.y) + 60 + 5,
                      x: _vm.checkNaN(node.x) + 15
                    }}}),_vm._v(" "),_c('v-text',{key:("node_api_method_" + (node.id)),attrs:{"config":{
                      width: 60,
                      align: 'center',
                      text: ("" + (node.answer[0][0].api_method)),
                      padding: 10,
                      y: _vm.checkNaN(node.y) + 60 + 5,
                      x: _vm.checkNaN(node.x) + 15,
                      fill: 'white'
                    }}}),_vm._v(" "),_c('v-text',{key:("node_api_name_" + (node.id)),attrs:{"config":{
                      width: 210,
                      text: ("" + (node.answer[0][0].api_name)),
                      padding: 10,
                      y: _vm.checkNaN(node.y) + 60 + 5,
                      x: _vm.checkNaN(node.x) + 15 + 60,
                      fill: '#61a9de'
                    }}})]:[_c('v-rect',{key:("node_message_empty_" + (node.id)),ref:("node_message_empty_" + (node.id)),refInFor:true,attrs:{"config":{
                      width: 270,
                      height: 30,
                      cornerRadius: 10,
                      fill: '#eee',
                      strokeWidth: 2,
                      stroke: '#eee',
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15
                    }}}),_vm._v(" "),_c('v-text',{key:("node_empty_" + (node.id)),attrs:{"config":{
                      width: 270,
                      text: 'Click to edit api',
                      padding: 10,
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15,
                      align: 'center'
                    }}})]]:(node.type == 'random')?[(node.answer && node.answer.length > 0 && node.answer[0].length > 0)?[_vm._l((node.answer[0][0].to),function(to,tindex){return [_c('v-rect',{key:("node_message_random_" + (node.id) + "_" + tindex),ref:("node_message_random_" + (node.id) + "_" + tindex),refInFor:true,attrs:{"config":{
                        width: 270,
                        height: 30,
                        cornerRadius:
                          node.answer[0][0].to.length != 1
                            ? tindex == node.answer[0][0].to.length - 1
                              ? [0, 0, 10, 10]
                              : tindex == 0
                              ? [10, 10, 0, 0]
                              : 0
                            : 10,
                        fill: 'white',
                        strokeWidth: 1,
                        stroke: '#61a9de',
                        y: _vm.checkNaN(node.y) + 60 + tindex * 30,
                        x: _vm.checkNaN(node.x) + 15
                      }}}),_vm._v(" "),_c('v-text',{key:("node_random_" + (node.id) + "_" + tindex),attrs:{"config":{
                        width: 270,
                        text: ("Random " + (tindex + 1)),
                        padding: 10,
                        y: _vm.checkNaN(node.y) + 60 + tindex * 30,
                        x: _vm.checkNaN(node.x) + 15,
                        fill: '#61a9de'
                      }}})]})]:[_c('v-rect',{key:("node_message_empty_" + (node.id)),ref:("node_message_empty_" + (node.id)),refInFor:true,attrs:{"config":{
                      width: 270,
                      height: 30,
                      cornerRadius: 10,
                      fill: '#eee',
                      strokeWidth: 2,
                      stroke: '#eee',
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15
                    }}}),_vm._v(" "),_c('v-text',{key:("node_empty_" + (node.id)),attrs:{"config":{
                      width: 270,
                      text: 'Click to edit random',
                      padding: 10,
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15,
                      align: 'center'
                    }}})]]:(node.type == 'flow')?[(
                    node.connected_intents &&
                      node.connected_intents.length > 0 &&
                      node.answer &&
                      node.answer.length > 0 &&
                      node.answer[0].length > 0
                  )?[_c('v-text',{key:("node_flow_title_" + (node.id)),attrs:{"config":{
                      width: 100,
                      text: 'Flow name',
                      fontStyle: 'bold',
                      padding: 10,
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15,
                      align: 'left'
                    }}}),_vm._v(" "),_c('v-text',{key:("node_flow_" + (node.id)),ref:("node_flow_" + (node.id)),refInFor:true,attrs:{"config":{
                      width: 170,
                      text: node.answer[0][0].flowname,
                      padding: 10,
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15 + 100,
                      align: 'left'
                    }}}),_vm._v(" "),_c('v-text',{key:("node_intent_title_" + (node.id)),attrs:{"config":{
                      width: 100,
                      text: 'Intent name',
                      fontStyle: 'bold',
                      padding: 10,
                      y:
                        _vm.checkNaN(node.y) +
                        60 +
                        (node.answer[0][0].flownameHeight &&
                        !isNaN(node.answer[0][0].flownameHeight)
                          ? node.answer[0][0].flownameHeight
                          : 0),
                      x: _vm.checkNaN(node.x) + 15,
                      align: 'left'
                    }}}),_vm._v(" "),_c('v-text',{key:("node_intent_" + (node.id)),ref:("node_intent_" + (node.id)),refInFor:true,attrs:{"config":{
                      width: 170,
                      text: node.answer[0][0].intentname,
                      padding: 10,
                      y:
                        _vm.checkNaN(node.y) +
                        60 +
                        (node.answer[0][0].flownameHeight &&
                        !isNaN(node.answer[0][0].flownameHeight)
                          ? node.answer[0][0].flownameHeight
                          : 0),
                      x: _vm.checkNaN(node.x) + 15 + 100,
                      align: 'left'
                    }}})]:[_c('v-rect',{key:("node_message_empty_" + (node.id)),ref:("node_message_empty_" + (node.id)),refInFor:true,attrs:{"config":{
                      width: 270,
                      height: 30,
                      cornerRadius: 10,
                      fill: '#eee',
                      strokeWidth: 2,
                      stroke: '#eee',
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15
                    }}}),_vm._v(" "),_c('v-text',{key:("node_empty_" + (node.id)),attrs:{"config":{
                      width: 270,
                      text: 'Click to edit flow',
                      padding: 10,
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15,
                      align: 'center'
                    }}})]]:(node.type == 'savevariables')?[(node.answer && node.answer.length > 0 && node.answer[0].length > 0)?[_vm._l((node.answer[0][0].variables),function(variable,vindex){return [_c('v-text',{key:("node_variable_" + (node.id) + "_" + vindex),ref:("node_variable_" + (node.id) + "_" + vindex),refInFor:true,attrs:{"config":{
                        width: 270,
                        text: variable.text,
                        padding: 10,
                        y: _vm.checkNaN(node.y) + 60 + _vm.checkNaN(variable.height),
                        x: _vm.checkNaN(node.x) + 15
                      }}}),_vm._v(" "),(vindex != 0)?_c('v-line',{key:("node_variable_line_" + (node.id) + "_" + vindex),attrs:{"config":{
                        x: _vm.checkNaN(node.x),
                        y: _vm.checkNaN(node.y) + 60 + variable.height,
                        strokeWidth: 1,
                        points: [0, 0, 300, 0],
                        stroke: '#eee'
                      }}}):_vm._e()]})]:[_c('v-rect',{key:("node_message_empty_" + (node.id)),ref:("node_message_empty_" + (node.id)),refInFor:true,attrs:{"config":{
                      width: 270,
                      height: 30,
                      cornerRadius: 10,
                      fill: '#eee',
                      strokeWidth: 2,
                      stroke: '#eee',
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15
                    }}}),_vm._v(" "),_c('v-text',{key:("node_empty_" + (node.id)),attrs:{"config":{
                      width: 270,
                      text: 'Click to edit variable',
                      padding: 10,
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15,
                      align: 'center'
                    }}})]]:[(node.answer && node.answer.length > 0 && node.answer[0].length > 0)?[_vm._l((node.answer),function(answer,aindex){return [_vm._l((answer),function(message,mindex){return [(message.type == 'text')?[_c('v-rect',{key:("node_message_" + (node.id) + "_" + aindex + "_" + mindex),attrs:{"config":{
                            width: 270,
                            height: message.messageHeight ? message.messageHeight : 50,
                            cornerRadius: 10,
                            fill: '#eee',
                            strokeWidth: 2,
                            stroke: '#eee',
                            y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                            x: _vm.checkNaN(node.x) + 15
                          }}}),_vm._v(" "),_c('v-text',{key:("node_answer_text_" + (node.id) + "_" + aindex + "_" + mindex),ref:("node_answer_text_" + (node.id) + "_" + aindex + "_" + mindex),refInFor:true,attrs:{"config":{
                            width: 270,
                            text: message.text,
                            padding: 10,
                            y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                            x: _vm.checkNaN(node.x) + 15,
                            lineHeight: 1.5
                          }}})]:(message.type == 'button')?[_c('v-rect',{key:("node_message_" + (node.id) + "_" + aindex + "_" + mindex),attrs:{"config":{
                            width: 270,
                            height: message.messageHeight ? message.messageHeight : 50,
                            cornerRadius:
                              message.buttons.length > 0 ? [10, 10, 0, 0] : [10, 10, 10, 10],
                            fill: '#eee',
                            strokeWidth: 2,
                            stroke: '#eee',
                            y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                            x: _vm.checkNaN(node.x) + 15
                          }}}),_vm._v(" "),_c('v-text',{key:("node_answer_text_" + (node.id) + "_" + aindex + "_" + mindex),ref:("node_answer_text_" + (node.id) + "_" + aindex + "_" + mindex),refInFor:true,attrs:{"config":{
                            width: 270,
                            text: message.text,
                            padding: 10,
                            y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                            x: _vm.checkNaN(node.x) + 15,
                            lineHeight: 1.5
                          }}}),_vm._v(" "),_vm._l((message.buttons),function(button,bindex){return [_c('v-rect',{key:("node_message_button_" + (node.id) + "_" + mindex + "_" + bindex),attrs:{"config":{
                              width: 270,
                              height: _vm.buttonHeight,
                              cornerRadius:
                                bindex == message.buttons.length - 1
                                  ? [0, 0, 10, 10]
                                  : [0, 0, 0, 0],
                              fill: 'white',
                              strokeWidth: 2,
                              stroke: '#eee',
                              y:
                                (message.messageHeight ? message.messageHeight : 50) +
                                (message.y ? message.y : 0) +
                                _vm.checkNaN(node.y) +
                                60 +
                                bindex * _vm.buttonHeight,
                              x: _vm.checkNaN(node.x) + 15
                            }}}),_vm._v(" "),_c('v-text',{key:("node_message_button_text_" + (node.id) + "_" + aindex + "_" + mindex + "_" + bindex),ref:("node_message_button_text_" + (node.id) + "_" + aindex + "_" + mindex),refInFor:true,attrs:{"config":{
                              width: 270,
                              height: _vm.buttonHeight,
                              text: button.title,
                              y:
                                (message.messageHeight ? message.messageHeight : 50) +
                                (message.y ? message.y : 0) +
                                _vm.checkNaN(node.y) +
                                60 +
                                bindex * _vm.buttonHeight,
                              x: _vm.checkNaN(node.x) + 15,
                              align: 'center',
                              fill: '#61a9de',
                              fontSize: 17,
                              offset: {
                                y: -10
                              }
                            }}})]})]:(message.type == 'image')?[(
                            message.loaded == true &&
                              message.image_url &&
                              message.image &&
                              _vm.isImage(message.image)
                          )?[_c('v-rect',{key:("node_image_" + (node.id) + "_" + aindex + "_" + mindex),attrs:{"config":{
                              width: 270,
                              height: _vm.imageHeight,
                              cornerRadius: 10,
                              fillPatternImage: message.image,
                              fillPatternRepeat: 'no-repeat',
                              fillPatternScale: {
                                x: 270 / message.image.width,
                                y: 270 / message.image.width
                              },
                              strokeWidth: 2,
                              stroke: '#eee',
                              y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                              x: _vm.checkNaN(node.x) + 15
                            }}})]:[_c('v-rect',{key:("node_image_" + (node.id) + "_" + aindex + "_" + mindex),attrs:{"config":{
                              width: 270,
                              height: _vm.imageHeight,
                              cornerRadius: 10,
                              fill: '#eee',
                              strokeWidth: 2,
                              stroke: '#eee',
                              y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                              x: _vm.checkNaN(node.x) + 15
                            }}})]]:(message.type == 'video' || message.type == 'audio')?[_c('v-rect',{key:("node_" + (message.type) + "_" + (node.id) + "_" + aindex + "_" + mindex),attrs:{"config":{
                            width: 270,
                            height: _vm.videoAndAudioHeight,
                            cornerRadius: 10,
                            fill: '#eee',
                            strokeWidth: 2,
                            stroke: '#eee',
                            y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                            x: _vm.checkNaN(node.x) + 15
                          }}}),_vm._v(" "),_c('v-text',{key:("node_" + (message.type) + "_text_" + (node.id) + "_" + aindex + "_" + mindex),ref:("node_" + (message.type) + "_text_" + (node.id) + "_" + aindex + "_" + mindex),refInFor:true,attrs:{"config":{
                            width: 270,
                            height: 20,
                            text: ("" + (message.type)),
                            y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                            x: _vm.checkNaN(node.x) + 15,
                            align: 'center',
                            fill: '#61a9de',
                            fontSize: 12,
                            offset: {
                              y: -10
                            }
                          }}}),_vm._v(" "),_c('v-text',{key:("node_" + (message.type) + "_source_" + (node.id) + "_" + aindex + "_" + mindex),ref:("node_" + (message.type) + "_source_" + (node.id) + "_" + aindex + "_" + mindex),refInFor:true,attrs:{"config":{
                            width: 270,
                            height: 20,
                            text: _vm.handleGetFileNameFromUrl(message.source),
                            y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0) + 20,
                            x: _vm.checkNaN(node.x) + 15,
                            align: 'center',
                            fill: 'black',
                            fontSize: 14,
                            offset: {
                              y: -10
                            }
                          }}})]:(message.type == 'generic')?[_vm._l((message.data),function(generic,gindex){return [_c('v-rect',{key:("node_message_" + (node.id) + "_" + aindex + "_" + mindex + "_" + gindex),attrs:{"config":{
                              width: 270,
                              height: generic.genericHeight ? generic.genericHeight : 141,
                              cornerRadius: 10,
                              fill: '#eee',
                              strokeWidth: 2,
                              stroke: '#eee',
                              y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                              x: _vm.checkNaN(node.x) + 15 + gindex * 295
                            }}}),_vm._v(" "),(
                              generic.loaded == true &&
                                generic.image_url &&
                                generic.image &&
                                _vm.isImage(generic.image)
                            )?[_c('v-rect',{key:("node_image_" + (node.id) + "_" + aindex + "_" + mindex + "_" + gindex),attrs:{"config":{
                                width: 270,
                                height: _vm.imageHeight,
                                cornerRadius: [10, 10, 0, 0],
                                fillPatternImage: generic.image,
                                fillPatternRepeat: 'no-repeat',
                                fillPatternScale: {
                                  x: 270 / generic.image.width,
                                  y: 270 / generic.image.width
                                },
                                strokeWidth: 2,
                                stroke: '#eee',
                                y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                                x: _vm.checkNaN(node.x) + 15 + gindex * 295
                              }}})]:[_c('v-rect',{key:("node_image_" + (node.id) + "_" + aindex + "_" + mindex + "_" + gindex),attrs:{"config":{
                                width: 270,
                                height: _vm.imageHeight,
                                cornerRadius: [10, 10, 0, 0],
                                fill: '#eee',
                                strokeWidth: 2,
                                stroke: '#eee',
                                y: _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0),
                                x: _vm.checkNaN(node.x) + 15 + gindex * 295
                              }}})],_vm._v(" "),_c('v-rect',{key:("node_generic_" + (node.id) + "_" + aindex + "_" + mindex + "_" + gindex),attrs:{"config":{
                              width: 270,
                              height: generic.genericMessageHeight
                                ? generic.genericMessageHeight
                                : 50,
                              cornerRadius: 0,
                              fill: 'white',
                              strokeWidth: 2,
                              stroke: '#eee',
                              y:
                                _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0) + _vm.imageHeight,
                              x: _vm.checkNaN(node.x) + 15 + gindex * 295
                            }}}),_vm._v(" "),_c('v-text',{key:("node_generic_title_" + (node.id) + "_" + aindex + "_" + mindex + "_" + gindex),ref:("node_generic_title_" + (node.id) + "_" + aindex + "_" + mindex + "_" + gindex),refInFor:true,attrs:{"config":{
                              width: 270,
                              text: generic.title,
                              padding: 10,
                              y:
                                _vm.checkNaN(node.y) + 60 + (message.y ? message.y : 0) + _vm.imageHeight,
                              x: _vm.checkNaN(node.x) + 15 + gindex * 295,
                              lineHeight: 1.2
                            }}}),_vm._v(" "),_c('v-text',{key:("node_generic_subtitle_" + (node.id) + "_" + aindex + "_" + mindex + "_" + gindex),ref:("node_generic_subtitle_" + (node.id) + "_" + aindex + "_" + mindex + "_" + gindex),refInFor:true,attrs:{"config":{
                              width: 270,
                              text: generic.subtitle,
                              padding: 10,
                              y:
                                _vm.checkNaN(node.y) +
                                60 +
                                (message.y ? message.y : 0) +
                                _vm.imageHeight +
                                generic.titleHeight,
                              x: _vm.checkNaN(node.x) + 15 + gindex * 295,
                              lineHeight: 1.2
                            }}}),_vm._v(" "),_vm._l((generic.buttons),function(button,bindex){return [_c('v-rect',{key:("node_message_generic_button_" + (node.id) + "_" + mindex + "_" + gindex + "_" + bindex),attrs:{"config":{
                                width: 270,
                                height: _vm.buttonHeight,
                                cornerRadius:
                                  bindex == generic.buttons.length - 1
                                    ? [0, 0, 10, 10]
                                    : [0, 0, 0, 0],
                                fill: 'white',
                                strokeWidth: 2,
                                stroke: '#eee',
                                y:
                                  (message.y ? message.y : 0) +
                                  _vm.checkNaN(node.y) +
                                  60 +
                                  bindex * _vm.buttonHeight +
                                  _vm.imageHeight +
                                  (generic.genericMessageHeight
                                    ? generic.genericMessageHeight
                                    : 0),
                                x: _vm.checkNaN(node.x) + 15 + gindex * 295
                              }}}),_vm._v(" "),_c('v-text',{key:("node_message_generic_button_text_" + (node.id) + "_" + aindex + "_" + mindex + "_" + gindex + "_" + bindex),ref:("node_message_generic_button_text_" + (node.id) + "_" + aindex + "_" + mindex),refInFor:true,attrs:{"config":{
                                width: 270,
                                height: _vm.buttonHeight,
                                text: button.title,
                                y:
                                  (message.y ? message.y : 0) +
                                  _vm.checkNaN(node.y) +
                                  60 +
                                  bindex * _vm.buttonHeight +
                                  _vm.imageHeight +
                                  (generic.genericMessageHeight
                                    ? generic.genericMessageHeight
                                    : 0),
                                x: _vm.checkNaN(node.x) + 15 + gindex * 295,
                                align: 'center',
                                fill: '#61a9de',
                                fontSize: 17,
                                offset: {
                                  y: -10
                                }
                              }}})]})]})]:(message.type == 'condition')?[_vm._l((message.condition),function(condition,cindex){return [_c('v-rect',{key:("node_message_condition_" + (node.id) + "_" + cindex),ref:("node_message_condition_" + (node.id) + "_" + cindex),refInFor:true,attrs:{"config":{
                              width: 270,
                              height: condition.messageHeight ? condition.messageHeight : 0,
                              cornerRadius:
                                message.condition.length == 1
                                  ? 10
                                  : cindex == message.condition.length - 1
                                  ? [0, 0, 10, 10]
                                  : cindex == 0
                                  ? [10, 10, 0, 0]
                                  : 0,
                              fill: 'white',
                              strokeWidth: 1,
                              stroke: '#61a9de',
                              y:
                                _vm.checkNaN(node.y) +
                                60 +
                                (condition.y ? condition.y : 0) +
                                (message.y ? message.y : 0),
                              x: _vm.checkNaN(node.x) + 15
                            }}}),_vm._v(" "),_c('v-text',{key:("node_answer_condition_" + (node.id) + "_" + aindex + "_" + mindex + "_" + cindex),ref:("node_answer_condition_" + (node.id) + "_" + aindex + "_" + mindex + "_" + cindex),refInFor:true,attrs:{"config":{
                              width: 270,
                              text: condition.caseText,
                              padding: 10,
                              y:
                                _vm.checkNaN(node.y) +
                                60 +
                                (condition.y ? condition.y : 0) +
                                (message.y ? message.y : 0),
                              x: _vm.checkNaN(node.x) + 15,
                              lineHeight: 1.5
                            }}})]})]:_vm._e()]})]})]:[_c('v-rect',{key:("node_message_empty_" + (node.id)),ref:("node_message_empty_" + (node.id)),refInFor:true,attrs:{"config":{
                      width: 270,
                      height: 30,
                      cornerRadius: 10,
                      fill: '#eee',
                      strokeWidth: 2,
                      stroke: '#eee',
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15
                    }}}),_vm._v(" "),_c('v-text',{key:("node_empty_" + (node.id)),attrs:{"config":{
                      width: 270,
                      text: 'Click to edit conversation',
                      padding: 10,
                      y: _vm.checkNaN(node.y) + 60,
                      x: _vm.checkNaN(node.x) + 15,
                      align: 'center'
                    }}})]],_vm._v(" "),(['start_node', 'node'].includes(node.type))?[(node.choices && node.choices.list)?[_vm._l((node.choices.list),function(choice,cindex){return [_c('v-rect',{key:("node_choice_" + (node.id) + "_" + cindex),attrs:{"config":{
                        width: choice.messageWidth,
                        height: choice.messageHeight ? choice.messageHeight : 50,
                        cornerRadius: 50,
                        fill: 'white',
                        strokeWidth: 2,
                        stroke: '#eee',
                        y: _vm.checkNaN(node.y) + 60 + (choice.y ? choice.y : 0),
                        x: _vm.checkNaN(node.x) + 15 - choice.messageWidth,
                        offset: {
                          x: -270,
                          y: 0
                        }
                      }}}),_vm._v(" "),_c('v-text',{key:("node_choice_text_" + (node.id) + "_" + cindex),ref:("node_choice_text_" + (node.id) + "_" + cindex),refInFor:true,attrs:{"config":{
                        text: choice.text,
                        padding: 10,
                        y: _vm.checkNaN(node.y) + 60 + (choice.y ? choice.y : 0),
                        x: _vm.checkNaN(node.x) + 15 - choice.messageWidth,
                        lineHeight: 1.5,
                        align: 'right',
                        offset: {
                          x: -270,
                          y: 0
                        }
                      }}})]})]:_vm._e(),_vm._v(" "),_c('v-rect',{key:("node_question_" + (node.id)),attrs:{"config":{
                    width: 270,
                    height: node.userinput.messageHeight ? node.userinput.messageHeight : 50,
                    cornerRadius: 10,
                    fill: 'white',
                    strokeWidth: 1,
                    stroke: '#61a9de',
                    y: _vm.checkNaN(node.y) + 60 + (node.userinput.y ? node.userinput.y : 0),
                    x: _vm.checkNaN(node.x) + 15
                  }}}),_vm._v(" "),_c('v-text',{key:("node_question_text_" + (node.id)),ref:("node_question_text_" + (node.id)),refInFor:true,attrs:{"config":{
                    width: 270,
                    text: 'User input',
                    padding: 10,
                    y: _vm.checkNaN(node.y) + 60 + (node.userinput.y ? node.userinput.y : 0),
                    x: _vm.checkNaN(node.x) + 15,
                    fill: '#61a9de'
                  }}})]:_vm._e()],2)]}),_vm._v(" "),_vm._l((_vm.connections),function(line,index){return [_c('v-group',{key:("connection_" + index + "_group"),ref:("connection_" + index + "_group"),refInFor:true},[(_vm.showDebug)?_c('v-text',{attrs:{"config":{
                  text: line.id,
                  x: line.points[0],
                  y: line.points[1]
                }}}):_vm._e(),_vm._v(" "),_c('v-line',{attrs:{"config":{
                  stroke: line.isHover ? '#61a9de' : '#9e9e9e',
                  strokeWidth: line.isHover ? 4 : 3,
                  bezier: line.isBezier,
                  points: line.points,
                  tension: line.tension ? line.tension : 0
                }},on:{"mouseover":function($event){return _vm.onLineMouseOver(index, $event)},"mouseleave":function($event){return _vm.onLineMouseLeave(index, $event)},"click":function($event){return _vm.onEditConnection()}}})],1)]}),_vm._v(" "),_vm._l((_vm.nodes),function(node,index){return [_c('v-group',{key:("node_group_pointer_" + (node.id)),ref:("node_group_pointer_" + (node.id)),refInFor:true},[_c('v-rect',{key:'node_action_' + index,ref:'node_' + node.id,refInFor:true,attrs:{"config":{
                  x: !isNaN(node.x) ? node.x : 0,
                  y: !isNaN(node.y) ? node.y : 0,
                  width: 300,
                  height: 60 + (node.height ? node.height : _vm.nodeHeight),
                  opacity: node.isHover || node.isSelect ? 1 : 0,
                  stroke: node.isSelect ? '#29b12f' : '#61a9de',
                  strokeWidth: 2,
                  cornerRadius: 10,
                  draggable: _vm.check_privilege
                }},on:{"dragstart":function($event){return _vm.onNodeMoveStart(index, $event)},"dragmove":function($event){return _vm.onNodeMove(index, $event)},"dragend":function($event){return _vm.onNodeMoveEnd(index, $event)},"mouseover":function($event){return _vm.onNodeMouseOver(index, $event)},"mouseleave":function($event){return _vm.onNodeMouseLeave(index, $event)},"click":function($event){return _vm.onNodeClick(index, $event)}}}),_vm._v(" "),(node.type == 'api')?[_c('v-circle',{key:("node_api_" + (node.id)),ref:("node_api_" + (node.id)),refInFor:true,attrs:{"config":{
                    radius: 6,
                    y: _vm.checkNaN(node.y) + 60 + (node.messageHeight ? node.messageHeight / 2 : 0),
                    x: _vm.checkNaN(node.x) + 300,
                    fill: node.to != 0 ? '#61a9de' : 'white',
                    stroke: '#61a9de',
                    strokeWidth: 1,
                    type: 'point'
                  }},on:{"mouseover":function($event){return _vm.onPointMouseOver(
                      { from: node.id, index: index, type: 'api', text: '' },
                      $event
                    )},"mouseleave":_vm.onPointMouseLeave}})]:(node.type == 'random')?[(node.answer && node.answer.length > 0 && node.answer[0].length > 0)?[_vm._l((node.answer[0][0].to),function(to,tindex){return [_c('v-circle',{key:("node_random_link_" + (node.id) + "_" + tindex),ref:("node_random_" + (node.id) + "_" + tindex),refInFor:true,attrs:{"config":{
                        radius: 6,
                        y: _vm.checkNaN(node.y) + 60 + tindex * 30 + 15,
                        x: 270 + _vm.checkNaN(node.x) + 15,
                        fill: to != 0 ? '#61a9de' : 'white',
                        stroke: '#61a9de',
                        type: 'point'
                      }},on:{"mouseover":function($event){return _vm.onPointMouseOver(
                          {
                            from: node.id,
                            index: index,
                            type: 'random',
                            tindex: tindex
                          },
                          $event
                        )},"mouseleave":_vm.onPointMouseLeave}})]})]:_vm._e()]:(node.type == 'flow')?void 0:(node.type == 'savevariables')?[_c('v-circle',{key:("node_savevariables_" + (node.id)),ref:("node_savevariables_" + (node.id)),refInFor:true,attrs:{"config":{
                    radius: 6,
                    y: _vm.checkNaN(node.y) + 60 + (node.messageHeight ? node.messageHeight / 2 : 0),
                    x: _vm.checkNaN(node.x) + 300,
                    fill: node.to != 0 ? '#61a9de' : 'white',
                    stroke: '#61a9de',
                    strokeWidth: 1,
                    type: 'point'
                  }},on:{"mouseover":function($event){return _vm.onPointMouseOver(
                      { from: node.id, index: index, type: 'savevariables', text: '' },
                      $event
                    )},"mouseleave":_vm.onPointMouseLeave}})]:[(['condition'].includes(node.type) == false)?[_c('v-rect',{key:("node_default_" + (node.id)),ref:("node_default_" + (node.id)),refInFor:true,attrs:{"config":{
                      width: 14,
                      height: 14,
                      y: _vm.checkNaN(node.y) + 60 + (node.height ? node.height : _vm.nodeHeight),
                      x: _vm.checkNaN(node.x) + 150,
                      fill: '#61a9de',
                      rotation: 45,
                      offset: {
                        x: 7,
                        y: 7
                      }
                    }},on:{"mouseover":function($event){return _vm.onPointMouseOver(
                        { from: node.id, index: index, type: 'text', text: '{default}' },
                        $event
                      )},"mouseleave":_vm.onPointMouseLeave}})]:_vm._e(),_vm._v(" "),_vm._l((node.answer),function(answer,aindex){return [_vm._l((answer),function(message,mindex){return [(message.type == 'text')?void 0:_vm._e(),_vm._v(" "),(message.type == 'button')?[_vm._l((message.buttons),function(button,bindex){return [(button.type == 'postback')?_c('v-circle',{key:("node_link_" + (node.id) + "_" + aindex + "_" + mindex + "_" + bindex),ref:("node_button_" + (node.id) + "_" + (button.payload)),refInFor:true,attrs:{"config":{
                            radius: 6,
                            y:
                              (message.messageHeight ? message.messageHeight : 50) +
                              _vm.checkNaN(node.y) +
                              60 +
                              bindex * _vm.buttonHeight +
                              (message.y ? message.y : 0) +
                              _vm.buttonHeight / 2,
                            x: 270 + _vm.checkNaN(node.x) + 15,
                            fill: button.payload ? '#61a9de' : 'white',
                            stroke: '#61a9de',
                            type: 'point'
                          }},on:{"mouseover":function($event){return _vm.onPointMouseOver(
                              {
                                from: node.id,
                                index: index,
                                type: 'postback',
                                text: button.payload,
                                aindex: aindex,
                                mindex: mindex,
                                bindex: bindex
                              },
                              $event
                            )},"mouseleave":_vm.onPointMouseLeave}}):_vm._e()]})]:(message.type == 'generic')?[_vm._l((message.data),function(generic,gindex){return [_vm._l((generic.buttons),function(button,bindex){return [(button.type == 'postback')?_c('v-circle',{key:("node_generic_link_" + (node.id) + "_" + aindex + "_" + mindex + "_" + gindex + "_" + bindex),ref:("node_generic_" + (node.id) + "_" + (button.payload)),refInFor:true,attrs:{"config":{
                              radius: 6,
                              y:
                                _vm.checkNaN(node.y) +
                                60 +
                                bindex * _vm.buttonHeight +
                                (message.y ? message.y : 0) +
                                _vm.buttonHeight / 2 +
                                _vm.imageHeight +
                                (generic.genericMessageHeight ? generic.genericMessageHeight : 0),
                              x: 270 + _vm.checkNaN(node.x) + 15 + gindex * 295,
                              fill: button.payload ? '#61a9de' : 'white',
                              stroke: '#61a9de',
                              type: 'point'
                            }},on:{"mouseover":function($event){return _vm.onPointMouseOver(
                                {
                                  from: node.id,
                                  index: index,
                                  type: 'generic',
                                  text: button.payload,
                                  aindex: aindex,
                                  mindex: mindex,
                                  bindex: bindex,
                                  gindex: gindex
                                },
                                $event
                              )},"mouseleave":_vm.onPointMouseLeave}}):_vm._e()]})]})]:(message.type == 'condition')?[_vm._l((message.condition),function(condition,cindex){return [_c('v-circle',{key:("node_condition_" + (node.id) + "_" + cindex),ref:("node_condition_" + (node.id) + "_" + cindex),refInFor:true,attrs:{"config":{
                            radius: 6,
                            y:
                              _vm.checkNaN(node.y) +
                              60 +
                              (condition.y ? condition.y : 0) +
                              (message.y ? message.y : 0) +
                              (condition.messageHeight ? condition.messageHeight / 2 : 0),
                            x: _vm.checkNaN(node.x) + 270 + 15,
                            fill: condition.to != 0 ? '#61a9de' : 'white',
                            stroke: '#61a9de',
                            strokeWidth: 1,
                            type: 'point'
                          }},on:{"mouseover":function($event){return _vm.onPointMouseOver(
                              {
                                from: node.id,
                                index: index,
                                type: 'condition',
                                text: '',
                                cindex: cindex
                              },
                              $event
                            )},"mouseleave":_vm.onPointMouseLeave}})]})]:_vm._e()]})]}),_vm._v(" "),(node.userinput && ['start_node', 'node'].includes(node.type))?[(node.choices && node.choices.list)?[_vm._l((node.choices.list),function(choice,cindex){return [_c('v-circle',{key:("node_quick_reply_" + (node.id) + "_" + cindex),ref:("node_quick_reply_" + (node.id) + "_" + (choice.text)),refInFor:true,attrs:{"config":{
                          radius: 6,
                          y:
                            _vm.checkNaN(node.y) +
                            60 +
                            choice.y +
                            (choice.messageHeight ? choice.messageHeight / 2 : 0),
                          x: _vm.checkNaN(node.x) + 270 + 15,
                          fill: node.to != 0 ? '#61a9de' : 'white',
                          stroke: '#61a9de',
                          strokeWidth: 1,
                          type: 'point'
                        }},on:{"mouseover":function($event){return _vm.onPointMouseOver(
                            {
                              from: node.id,
                              index: index,
                              type: 'quick_reply',
                              text: choice.text
                            },
                            $event
                          )},"mouseleave":_vm.onPointMouseLeave}})]})]:_vm._e(),_vm._v(" "),_c('v-circle',{key:("node_input_" + (node.id)),ref:("node_input_" + (node.id)),refInFor:true,attrs:{"config":{
                      radius: 6,
                      y:
                        _vm.checkNaN(node.y) +
                        60 +
                        (node.userinput.y ? node.userinput.y : 0) +
                        (node.userinput.messageHeight ? node.userinput.messageHeight / 2 : 0),
                      x: _vm.checkNaN(node.x) + 15 + 270,
                      fill: node.userinput.hasUserInput ? '#61a9de' : 'white',
                      stroke: '#61a9de',
                      strokeWidth: 1,
                      type: 'point'
                    }},on:{"mouseover":function($event){return _vm.onPointMouseOver({ from: node.id, index: index, type: 'text' }, $event)},"mouseleave":_vm.onPointMouseLeave}})]:_vm._e()],_vm._v(" "),_c('v-regular-polygon',{key:("connections_" + (node.id)),ref:("connections_" + (node.id)),refInFor:true,attrs:{"config":{
                  sides: 3,
                  radius: 10,
                  y: _vm.checkNaN(node.y) + 60 + (node.height ? node.height : _vm.nodeHeight) / 2,
                  x: !isNaN(node.x) ? node.x : 0,
                  fill: '#61a9de',
                  rotation: 90
                }}})],2)]}),_vm._v(" "),(_vm.relationPointer)?_c('v-regular-polygon',{ref:"cursor",attrs:{"config":{
              radius: _vm.isDragRelation ? 6 : 10,
              y: !isNaN(_vm.relationPointer.y) && _vm.relationPointer.y ? _vm.relationPointer.y : 0,
              x: !isNaN(_vm.relationPointer.x) && _vm.relationPointer.x ? _vm.relationPointer.x : 0,
              fill: '#61a9de',
              sides: _vm.isDragRelation ? 3 : 4,
              opacity: _vm.isDragRelation ? 1 : 0,
              scale: { x: 1.4, y: 1.4 },
              draggable: _vm.check_privilege,
              rotation: _vm.isDragRelation ? (_vm.arrowDirection == 'right' ? 90 : -90) : -45
            }},on:{"dragstart":_vm.onRelationStart,"dragmove":_vm.onRelationMove,"dragend":_vm.onRelationEnd}}):_vm._e(),_vm._v(" "),_c('v-line',{attrs:{"config":{
              stroke: '#61a9de',
              strokeWidth: 2,
              opacity: _vm.isDragRelation ? 1 : 0,
              bezier: true,
              points: _vm.relationLine
            }}}),_vm._v(" "),(_vm.lineDetail)?_c('v-circle',{attrs:{"config":{
              radius: 15,
              x: !isNaN(_vm.lineDetail.x) && _vm.lineDetail.x ? _vm.lineDetail.x : 0,
              y: !isNaN(_vm.lineDetail.y) && _vm.lineDetail.y ? _vm.lineDetail.y : 0,
              fill: '#61a9de',
              visible: _vm.check_privilege && _vm.showToolConnection && _vm.lineDetail.type != 'start_node'
            }},on:{"mouseover":_vm.onLineOptionMouseOver,"mouseleave":_vm.onLineOptionMouseLeave,"click":function($event){return _vm.onEditConnection()}}}):_vm._e(),_vm._v(" "),(_vm.lineDetail)?_c('v-path',{attrs:{"config":{
              x: !isNaN(_vm.lineDetail.x) && _vm.lineDetail.x ? _vm.lineDetail.x : 0,
              y: !isNaN(_vm.lineDetail.y) && _vm.lineDetail.y ? _vm.lineDetail.y : 0,
              data:
                'm415.402344 495.421875-159.40625-159.410156-159.40625 159.410156c-22.097656 22.09375-57.921875 22.09375-80.019532 0-22.09375-22.097656-22.09375-57.921875 0-80.019531l159.410157-159.40625-159.410157-159.40625c-22.09375-22.097656-22.09375-57.921875 0-80.019532 22.097657-22.09375 57.921876-22.09375 80.019532 0l159.40625 159.410157 159.40625-159.410157c22.097656-22.09375 57.921875-22.09375 80.019531 0 22.09375 22.097657 22.09375 57.921876 0 80.019532l-159.410156 159.40625 159.410156 159.40625c22.09375 22.097656 22.09375 57.921875 0 80.019531-22.097656 22.09375-57.921875 22.09375-80.019531 0zm0 0',
              fill: 'white',
              scale: {
                x: 0.025,
                y: 0.025
              },
              offset: {
                x: 250,
                y: 250
              },
              visible:
                _vm.check_privilege &&
                _vm.showToolConnection &&
                _vm.lineDetail.type != 'start_node' &&
                _vm.lineDetail.type != 'input'
            }}}):_vm._e(),_vm._v(" "),(_vm.lineDetail)?_c('v-rect',{attrs:{"config":{
              x: !isNaN(_vm.lineDetail.x) && _vm.lineDetail.x ? _vm.lineDetail.x : 0,
              y: !isNaN(_vm.lineDetail.y) && _vm.lineDetail.y ? _vm.lineDetail.y : 0,
              fill: 'white',
              stroke: _vm.lineDetail.strokeColor,
              width: _vm.lineDetail.width > 50 ? _vm.lineDetail.width : 50,
              height: _vm.lineDetail.height,
              visible:
                _vm.check_privilege &&
                _vm.showToolConnection &&
                _vm.lineDetail.type == 'input' &&
                _vm.lineDetail.type != 'start_node',
              cornerRadius: 10,
              offset: {
                x: (_vm.lineDetail.width > 50 ? _vm.lineDetail.width : 50) / 2,
                y: _vm.lineDetail.height / 2
              }
            }},on:{"mouseover":_vm.onLineOptionMouseOver,"mouseleave":_vm.onLineOptionMouseLeave,"click":function($event){return _vm.onEditConnection()}}}):_vm._e(),_vm._v(" "),(_vm.lineDetail)?_c('v-text',{ref:"line_detail",attrs:{"config":{
              text: _vm.lineDetail.text,
              padding: 10,
              x: !isNaN(_vm.lineDetail.x) && _vm.lineDetail.x ? _vm.lineDetail.x : 0,
              y: !isNaN(_vm.lineDetail.y) && _vm.lineDetail.y ? _vm.lineDetail.y : 0,
              visible: _vm.check_privilege && _vm.showToolConnection && _vm.lineDetail.type == 'input',
              offset: {
                x: _vm.lineDetail.width / 2,
                y: _vm.lineDetail.height / 2
              }
            }},on:{"mouseover":_vm.onLineOptionMouseOver,"mouseleave":_vm.onLineOptionMouseLeave,"click":function($event){return _vm.onEditConnection()}}}):_vm._e(),_vm._v(" "),(_vm.lineDetail)?_c('v-rect',{attrs:{"config":{
              x: !isNaN(_vm.lineDetail.x) && _vm.lineDetail.x ? _vm.lineDetail.x : 0,
              y:
                (!isNaN(_vm.lineDetail.y) && _vm.lineDetail.y ? _vm.lineDetail.y : 0) + _vm.lineDetail.height - 2,
              fill: _vm.lineDetail.strokeColor,
              width: 30,
              height: 30,
              visible:
                _vm.check_privilege &&
                _vm.showToolConnection &&
                _vm.lineDetail.type == 'input' &&
                _vm.lineDetail.type != 'start_node',
              cornerRadius: [0, 0, 10, 10],
              offset: {
                x: 30 / 2,
                y: 30 / 2
              }
            }},on:{"mouseover":_vm.onLineOptionMouseOver,"mouseleave":_vm.onLineOptionMouseLeave,"click":function($event){return _vm.onEditConnection()}}}):_vm._e(),_vm._v(" "),(_vm.lineDetail)?_c('v-path',{attrs:{"config":{
              x: !isNaN(_vm.lineDetail.x) && _vm.lineDetail.x ? _vm.lineDetail.x : 0,
              y:
                (!isNaN(_vm.lineDetail.y) && _vm.lineDetail.y ? _vm.lineDetail.y : 0) + _vm.lineDetail.height - 2,
              data:
                'm487.050781 24.917969c-33.304687-33.222657-87.210937-33.222657-120.511719 0l-337.457031 337.453125c-2.371093 2.375-3.992187 5.398437-4.652343 8.691406l-24.082032 120.445312c-1.882812 9.222657 4.0625 18.222657 13.285156 20.109376 2.253907.460937 4.574219.460937 6.828126 0l120.527343-24.097657c3.292969-.664062 6.316407-2.28125 8.691407-4.65625l337.457031-337.453125c33.183593-33.324218 33.148437-87.21875-.085938-120.492187zm-421.800781 349.484375 241.023438-241.023438 72.3125 72.3125-241.023438 241.027344zm265.121094-265.121094 12.066406-12.066406 72.316406 72.3125-12.066406 12.066406zm-278.757813 299.6875 51.386719 51.382812-64.234375 12.851563zm411.335938-287.640625-24.097657 24.101563-72.3125-72.316407 24.097657-24.097656c19.96875-19.96875 52.34375-19.96875 72.3125 0s19.96875 52.34375 0 72.3125zm0 0',
              fill: 'white',
              scale: {
                x: 0.025,
                y: 0.025
              },
              offset: {
                x: 250,
                y: 250
              },
              visible: _vm.check_privilege && _vm.showToolConnection && _vm.lineDetail.type == 'input'
            }}}):_vm._e(),_vm._v(" "),(_vm.selectionConfig)?_c('v-rect',{ref:"selectionrect",attrs:{"config":{
              x: !isNaN(_vm.selectionConfig.x) && _vm.selectionConfig.x ? _vm.selectionConfig.x : 0,
              y: !isNaN(_vm.selectionConfig.y) && _vm.selectionConfig.y ? _vm.selectionConfig.y : 0,
              height: _vm.selectionConfig.height,
              width: _vm.selectionConfig.width,
              visible: _vm.selectionConfig.visible,
              fill: '#9eff2040',
              stroke: '#9eff20'
            }}}):_vm._e()],2)],1)]],2):_vm._e(),_vm._v(" "),(_vm.showDeleteNode)?_c('div',{staticClass:"pa-2",staticStyle:{"position":"absolute"},style:({ top: _vm.optionPos.y + 'px', left: _vm.optionPos.x + 'px' }),on:{"mouseover":_vm.onDeleteNodeMouseOver,"mouseleave":_vm.onDeleteNodeMouseLeave}},[_c('v-btn',{staticClass:"extra-small ma-0",attrs:{"fab":"","depressed":"","small":"","color":"primary"},on:{"click":_vm.onDeleteNode}},[_c('v-icon',[_vm._v("delete")])],1)],1):_vm._e(),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"right":"","temporary":"","fixed":""},model:{value:(_vm.showDial),callback:function ($$v) {_vm.showDial=$$v},expression:"showDial"}},[_c('div',{staticClass:"pa-3"},[_c('v-btn',{staticClass:"ml-0 mr-0",staticStyle:{"width":"100%"},attrs:{"depressed":"","large":""},on:{"click":function($event){$event.stopPropagation();return _vm.addNode('node')}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("add_box")]),_vm._v("Add Node\n      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 mr-0",staticStyle:{"width":"100%"},attrs:{"depressed":"","color":_vm.$store.state.colorlist.api,"large":""},on:{"click":function($event){$event.stopPropagation();return _vm.addNode('api')}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("http")]),_vm._v("Add api\n      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 mr-0",staticStyle:{"width":"100%"},attrs:{"depressed":"","color":_vm.$store.state.colorlist.random,"large":""},on:{"click":function($event){$event.stopPropagation();return _vm.addNode('random')}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("shuffle")]),_vm._v("Add Randomize\n      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 mr-0",staticStyle:{"width":"100%"},attrs:{"depressed":"","color":_vm.$store.state.colorlist.condition,"large":""},on:{"click":function($event){$event.stopPropagation();return _vm.addNode('condition')}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("call_split")]),_vm._v("Add Condition\n      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 mr-0",staticStyle:{"width":"100%"},attrs:{"depressed":"","color":_vm.$store.state.colorlist.flow,"large":""},on:{"click":function($event){$event.stopPropagation();return _vm.addNode('flow')}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("account_tree")]),_vm._v("Add Flow\n      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 mr-0",staticStyle:{"width":"100%"},attrs:{"depressed":"","color":_vm.$store.state.colorlist.savevariables,"large":""},on:{"click":function($event){$event.stopPropagation();return _vm.addNode('savevariables')}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("save")]),_vm._v("Save variable\n      ")],1)],1)]),_vm._v(" "),(_vm.nodes.length > 0)?_c('div',{staticStyle:{"position":"absolute","right":"10px","top":"60px"}},[(_vm.check_privilege)?_c('div',[_c('v-btn',{attrs:{"color":"primary","fab":"","dark":""},on:{"click":function($event){_vm.showDial = true}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"white","fab":"","small":""},on:{"click":_vm.repositionStage}},[_c('v-icon',[_vm._v("settings_overscan")])],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"position":"fixed","bottom":"0","left":"0","right":"0","text-align":"center"}},[(_vm.holdNewNodeOnHand)?_c('div',{staticStyle:{"margin":"auto","display":"inline-block","padding":"10px","background":"#00000066","border-radius":"10px,10px,0,0","border-top-right-radius":"10px","border-top-left-radius":"10px","color":"white"}},[_vm._v("\n      Click on empty space to drop new node\n    ")]):(_vm.isBeforePaste)?_c('div',{staticStyle:{"margin":"auto","display":"inline-block","padding":"10px","background":"#00000066","border-radius":"10px,10px,0,0","border-top-right-radius":"10px","border-top-left-radius":"10px","color":"white"}},[_vm._v("\n      Click on empty space to drop copy nodes\n    ")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c52a6238","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/flow/FlowCanvas.vue
// module id = null
// module chunks = 